module.exports = __webpack_public_path__ + "img/sh-adidas-half-marathon-2018.adfa913d.jpg";